<template>
  <div>
    <v-textarea
      class="mt-4"
      outlined
      hide-details="auto"
      v-model="comment"
      :auto-grow="true"
      :no-resize="!$vuetify.breakpoint.mdAndUp"
      rows="3"
      :autofocus="true"
      :disabled="disableButton"
      :placeholder="$t('listActions.rejectAll.placeholder')"
    />

    <div class="d-flex flex-wrap justify-end">
      <v-btn
        class="mt-4"
        color="primary"
        right
        :block="!$vuetify.breakpoint.mdAndUp"
        dark
        @click="send"
        :loading="disableButton"
      >
        {{ $t("listActions.rejectAll.send") }}
      </v-btn>

      <v-btn
        class="mt-4 ml-4"
        :block="!$vuetify.breakpoint.mdAndUp"
        right
        :disabled="disableButton"
        @click="$emit('close')"
      >
        {{ $t("commons.cancel") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tickets: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      disableButton: false,
      comment: '',
    };
  },

  methods: {
    async send() {
      if (this.tickets.length === 0) {
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('validation.required'),
          icon: 'mdi-times',
          type: 'error',
          timeout: this.$getConst('notifications.timeout'),
        });
        return;
      }
      const messageId = await this.$store.dispatch(
        'messages/createNotificationMessage',
        {
          icon: 'progress-circular',
          title: this.$tc('listActions.rejectAll.creating', this.tickets.length),
        },
      );

      try {
        const listTicketId = this.tickets.flatMap((ticket) => ticket.id);
        this.disableButton = true;
        const response = await this.client.rejectAll(listTicketId, this.comment);
        const errors = [];

        if (response.list[0].errors.length > 0) {
          this.tickets.forEach((ticket) => {
            if (response.list[0].errors.find((err) => err.ticket_id === ticket.id)) {
              errors.push(ticket.referenceNumber);
            }
          });
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'error',
            icon: 'mdi-close-circle',
            title: `${this.$t('listActions.rejectAll.errorsTicket')} ${errors.join(' ')}`,
            timeout: this.$getConst('notifications.timeout'),
          });
        } else {
          this.$store.dispatch('messages/updateMessage', {
            id: messageId,
            type: 'success',
            icon: 'mdi-check-circle',
            title: this.$tc('listActions.rejectAll.successTicket', this.tickets.length),
            timeout: this.$getConst('notifications.timeout'),
          });
        }
        await this.$store.dispatch('tickets/totalApprovalsNext');
      } catch (ex) {
        console.error('error approving ticket', ex);
        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'error',
          icon: 'mdi-close-circle',
          title: this.$t('listActions.rejectAll.error'),
          timeout: this.$getConst('notifications.timeout'),
        });
      }

      this.disableButton = false;

      this.$emit('close'); // action block closing
      this.$emit('refresh:list');
    },
  },
  created() {
    this.client = this.$api.getClient('ticket');
  },
};
</script>
